// Видимая часть экрана на телефоне. Клавиатура iPhone не уменьшает страницу — она закрывает её низ, и поле ввода
// чата оказывалось под клавиатурой. Высота и сдвиг видимой части — в CSS-переменных --vvh и --vvt, а пока открыта
// клавиатура, у <html> класс kb: чат и каркас ужимаются до видимой части (index.css, «Телефон: клавиатура»).
const vv = typeof window !== 'undefined' ? window.visualViewport : null;

if (vv) {
  const root = document.documentElement;
  let frame = 0;
  const apply = () => {
    frame = 0;
    root.style.setProperty('--vvh', `${Math.round(vv.height)}px`);
    root.style.setProperty('--vvt', `${Math.round(vv.offsetTop)}px`);
    // Клавиатура: видимая часть заметно ниже окна (адресная строка браузера — меньше 120 px)
    root.classList.toggle('kb', window.innerHeight - vv.height > 120);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(apply);
  };
  vv.addEventListener('resize', schedule);
  vv.addEventListener('scroll', schedule);
  apply();
}
